import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { TranslateContext } from '../../../../common/translator'
import { Button } from 'chemistry'
import FilterIcon from 'client/fragments/listerFragment/components/FilterButton/FilterIcon'
import { FilterAppliedIcon } from 'client/fragments/listerFragment/components/FilterButton/FilterAppliedIcon'

const notSortedValues = ['', 'relevance']
const FilterButton = ({ visible, onClick, activeFilters, sortBy }) => {
  const t = useContext(TranslateContext)
  if (!visible) return null
  const filtersCount = Object.keys(activeFilters).reduce((acc, key) => activeFilters[key].length + acc, 0)
  const isSorted = !notSortedValues.includes(sortBy)

  return (
    <Button
      onClick={onClick}
      display='flex'
      paddingBlock='2px'
      gap='1ch'
      variant='primaryGrey'
      bottom='sx'
      position='fixed'
      zIndex={1}
      tabIndex={0}
      left='50%'
      width='180px'
      transform='translateX(-50%)'
      className='sm-only'
    >
      <FilterIcon />
      {t('lister.filters.toggle_btn')}
      {(!!filtersCount || isSorted) && <FilterAppliedIcon />}
    </Button>
  )
}

FilterButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.string
}

export default FilterButton
